import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export function initSubmenuSwiper() {
    Swiper.use([Navigation]);

    document.querySelectorAll('.nav-swiper').forEach((el) => {
        const slides = el.querySelectorAll('.level_1');
        const activeEl = el.querySelector('.level_1.is-active');
        const initialIndex = activeEl ? Array.from(slides).indexOf(activeEl) : 0;

        const gap = 12;
        const leftPad = 20;

        const swiper = new Swiper(el, {
            slideClass: 'level_1',
            slidesPerView: 'auto',
            spaceBetween: gap,
            freeMode: true,
            mousewheel: true,
            watchOverflow: false,
            roundLengths: true,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: leftPad,
            centeredSlides: false,
            navigation: {
                nextEl: el.querySelector('.swiper-button-next'),
                prevEl: el.querySelector('.swiper-button-prev'),
            },
            observer: true,
            observeParents: true,
            on: {
                init: function() {
                    if (activeEl && initialIndex >= 0) {
                        setTimeout(() => {
                            const activeSlide = activeEl;
                            if (activeSlide) {
                                const slideOffset = activeSlide.offsetLeft;
                                const previousSlide = activeSlide.previousElementSibling;

                                if (previousSlide) {
                                    const prevSlideOffset = previousSlide.offsetLeft;
                                    this.setTranslate(-prevSlideOffset);
                                } else {
                                    this.setTranslate(-slideOffset);
                                }
                                this.updateProgress();
                            }
                        }, 150);
                    }
                }
            }
        });
    });
}